export default __webpack_public_path__ + "90f98ad6ac046d4dc367b3047716aec7.svg";